import { io } from 'socket.io-client';

export const nodeSocket = io(process.env.GRAPHQL_SERVER_ENDPOINT, { withCredentials: true, autoConnect: false });
export const pythonSocket = io(process.env.VIRGIL_URL, { withCredentials: true, autoConnect: false });
